import PropTypes from 'prop-types'
import { gql } from '@apollo/client'

const money = gql`
  fragment money on Money {
    amount
    currency
  }
`

export const moneyPropTypes = PropTypes.shape({
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
})

export default money
